export const ACTIONS = Object.freeze({
  RE_ADD: "RE_ADD",
  REMOVE: "REMOVE",
});

export const MODAL_KEYS = Object.freeze({
  RE_ADD: "whitelisting_re_add_modal",
  REMOVE: "whitelisting_remove_modal",
  LOGS: "whitelisting_logs_modal",
});

export const WHITELISTED_ITEM_DEFAULTS = Object.freeze({
  customerId: null,
  customerName: null,
  addedBy: null,
  addedDateTime: null,
  removedBy: null,
  removedDateTime: null,
  addedNotes: null,
  removedNotes: null,
  actions: null,
  showLogs: null,
});
